import React from 'react'
import { withState } from 'recompose'
import PopOver from 'react-popover'

export function hoverable(OriginalComponent) {
  const Hoverable = ({ hovered, setHovered, children, ...originalProps }) => {
    return React.createElement(
      'div',
      {
        onMouseOver: () => setHovered(true),
        onMouseLeave: () => setHovered(false),
      },
      React.createElement(
        OriginalComponent,
        {
          hovered,
          ...originalProps,
        },
        children
      )
    )
  }
  return withState('hovered', 'setHovered', false)(Hoverable)
}

export const WithTooltip = hoverable(({ hovered, popOverProps, children }) => {
  return (
    <PopOver isOpen={hovered} target={children} {...popOverProps}>
      {children}
    </PopOver>
  )
})



// WEBPACK FOOTER //
// ./src/components/utils.js